<template>
  <div class="row bg-white m-0 p-2 mb-2">
    <div class="col-12 col-md-7  pt-3">
      <h5
        class="font-weight-bold font-16 color-black"
        v-text="item.article.name || '-'"
      />
    </div>

    <div class="col-10 col-md-4 pt-3">
      <ValidationProvider
        v-slot="{ errors }"
        rules="required"
        tag="div"
        class="d-md-flex flex-column align-items-end"
      >
        <div class="d-md-flex">
          <span class="regular text-gray align-self-center">
            Cantidad:
          </span>
          <CustomInput
            v-model.number="item.quantity"
            :disabled="submitted"
            class="ml-md-2 mt-1 mt-md-0"
            type="number"
            :error="errors[0]"
            custom-error-msg=""
          />
        </div>
        <error
          v-if="errors[0]"
          message="La cantidad es requerida."
          variant="no-border pr-0"
        />
      </ValidationProvider>
    </div>

    <div v-if="!submitted" class="col-2 pt-2 col-md-1 px-0 ml-auto">
      <div class="d-flex align-items-center justify-content-end h-100 w-100">
        <ActionButton
          i="fas fa-times-circle fa-2x color-primary-17"
          @click="$emit('remove', item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import Error from 'custom-error';

export default {
  name: 'Item',
  components: {
    ActionButton,
    CustomInput,
    Error,
  },
  props: {
    item: { type: Object, default: null },
    submitted: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped></style>
